module.exports = __webpack_public_path__ + "static/img/case16.57e2d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case16.jpg
// module id = ok0p
// module chunks = 0